module.exports = __webpack_public_path__ + "static/og-613c50f00ab5290e337e7e78e8b65c98.png";